import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICategoryResource, ICategoryTranslationResource } from "../types";

export type ICategoryTranslationQueryParameters = {
    category?: RelationalValue<ICategoryResource>;
    locale?: string;
};

export type ICategoryTranslationQueryResult = ICategoryTranslationResource;

export const categoryTranslationQuery: IApiQueryFunction<ICategoryTranslationQueryParameters> = ({
    category,
    locale,
}) => {
    if (!category && !locale) {
        return;
    }

    return {
        method: "GET",
        url: `/categories/${mapRelationalValue(category)}/translations/${locale}`,
    };
};

export const useCategoryTranslationQuery = createApiQueryHook<
    ICategoryTranslationQueryParameters,
    ICategoryTranslationQueryResult
>(categoryTranslationQuery);
